<div class="show-task-popup-container">
    <div class="row">
        <div class="col-md-12">
            <lfwms-result-data-table [searchService]="lookupSearchService"
                [tableMode]="lookupSearchService.getDisplayMode()"
                (buttonActionHandler)="handleButtonAction($event)">
            </lfwms-result-data-table>
        </div>
    </div>
</div>